import { Link } from "react-router-dom";
import { useI18n } from "@/i18n/I18nProvider";

const PAGES = ["about", "contact", "privacy", "terms", "safety", "report"];

export default function Footer() {
  const { t } = useI18n();
  return (
    <footer className="bg-navy-dark text-white/80 mt-20" data-testid="site-footer">
      <div className="crenel" />
      <div className="mx-auto max-w-7xl px-4 py-12 grid gap-10 md:grid-cols-3">
        <div className="space-y-3">
          <img src="/brand/lockup-dark.png" alt="باب اليمن — BAB AL YEMEN — للعقارات" width="160" height="148" loading="lazy" className="w-40 h-auto" data-testid="footer-logo" />
          <p className="text-sm leading-relaxed">{t("brand.desc")}</p>
          <p className="text-xs text-gold-light">{t("footer.freeNote")}</p>
        </div>
        <nav className="grid grid-cols-2 gap-2 text-sm">
          {PAGES.map((p) => (
            <Link key={p} to={`/page/${p}`} data-testid={`footer-link-${p}`} className="hover:text-gold-light">{t(`footer.${p}`)}</Link>
          ))}
        </nav>
        <div className="text-xs leading-relaxed text-white/60">{t("currencyNote")}</div>
      </div>
      <div className="border-t border-white/10 py-4 text-center text-xs text-white/50">
        © {new Date().getFullYear()} {t("brand.name")} — {t("footer.rights")}
      </div>
    </footer>
  );
}
